export default {
    created() {
        const originUserMenus = this.$store.state.originUserMenus;
        let list = originUserMenus.map(item => item.menuUrl);
        this.settingOption = this.settingOption.filter(item => list.includes(item.path))
    },
}